import { createFileRoute } from "@tanstack/react-router";
import { motion } from "motion/react";
import { useEffect, useState } from "react";
import { LessonPageLayout } from "#/modules/les.leerling-gestuurd/components/lesson-page-layout";
import { BeweegactiviteitQuestion } from "#/modules/les.leerling-gestuurd/components/question.beweegactiviteit";
import { BeweegactiviteitMultipleQuestion } from "#/modules/les.leerling-gestuurd/components/question.beweegactiviteit-multiple";
import { VrijBeweegdoelQuestion } from "#/modules/les.leerling-gestuurd/components/question.vrij-beweegdoel";
import { SuccessAnimation } from "#/modules/les.leerling-gestuurd/components/shared.success-animation";
import {
  getActivityById,
  getStudentNameById,
} from "#/modules/les.leerling-gestuurd/helpers.les.leerling";
import { useLeerlingGestuurdeLes } from "#/modules/les.leerling-gestuurd/use-leerling-gestuurde-les";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lesson/$lesson/student/$student/activity/$id/",
)({
  component: StudentActivityPage,
});

function StudentActivityPage() {
  const params = Route.useParams();
  const { lesson } = useLeerlingGestuurdeLes();
  const [isSuccess, setIsSuccess] = useState(false);
  const activity = getActivityById(lesson, params.id);
  const student = getStudentNameById(lesson, params.student);
  const beweegactiviteit = lesson.beweegactiviteiten.find((item) => item.id === params.id);

  useEffect(() => {
    setIsSuccess(false);
  }, [params.id, params.student]);

  return (
    <LessonPageLayout
      title={
        <h1 className="m-0 flex items-center justify-center gap-4">
          {student} — {activity?.name}
          {beweegactiviteit?.icon?.svg && (
            <span
              className="flex size-10 shrink-0 items-center justify-center
                  opacity-80 [&_svg]:size-full! [&_svg]:text-current"
              dangerouslySetInnerHTML={{
                __html: beweegactiviteit.icon.svg,
              }}
            />
          )}
        </h1>
      }
      contentClassName="gap-20 max-w-[1200px]"
      showBackButton={true}
    >
      <SuccessAnimation isSuccess={isSuccess} lessonId={params.lesson} />

      {activity?.type === "VrijBeweegdoel" && activity?.vrijBeweegdoel ? (
        <motion.div
          key="vrij-beweegdoel-question"
          className="w-full"
          animate={isSuccess ? { opacity: 0, scale: 0.9 } : { opacity: 1, scale: 1 }}
        >
          <VrijBeweegdoelQuestion
            vrijBeweegdoel={activity.vrijBeweegdoel}
            onSuccess={() => setIsSuccess(true)}
          />
        </motion.div>
      ) : activity?.type === "Meerkeuze" ? (
        <motion.div
          key="beweegdoel-multiple-question"
          className="w-full"
          animate={isSuccess ? { opacity: 0, scale: 0.9 } : { opacity: 1, scale: 1 }}
        >
          <BeweegactiviteitMultipleQuestion
            beweegdoelen={activity?.beweegdoelen || []}
            activityName={activity?.name}
            onSuccess={() => setIsSuccess(true)}
          />
        </motion.div>
      ) : (
        <motion.div
          className="w-full"
          key="beweegdoel-question"
          animate={isSuccess ? { opacity: 0, scale: 0.9 } : { opacity: 1, scale: 1 }}
        >
          <BeweegactiviteitQuestion
            beweegdoelen={activity?.beweegdoelen || []}
            activityName={activity?.name}
            onSuccess={() => setIsSuccess(true)}
          />
        </motion.div>
      )}
    </LessonPageLayout>
  );
}
